module.exports = __webpack_public_path__ + "static/media/narval-logo-mobile.432a8c99.svg";